<template>
  <div v-if="account.idTokenClaims.given_name" class="topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
      <span class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
        {{ account.idTokenClaims.given_name }}
      </span>
      <span class="symbol symbol-35 symbol-light-success">
        <span class="symbol-label font-size-h5 font-weight-bold">
          {{ account.idTokenClaims.given_name | firstCharacter }}
        </span>
      </span>
    </div>

    <div id="kt_quick_user" ref="kt_quick_user" class="offcanvas offcanvas-right p-10">
      <!--begin::Header-->
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 class="font-weight-bold m-0">
          SKR-Account
          <!--<small class="text-muted font-size-sm ml-2">12 messages</small>-->
        </h3>
        <a href="#" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_user_close">
          <X :size="14" class="text-muted" />
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5">
            <span class="symbol symbol-35 symbol-light-success">
              <span class="symbol-label font-size-h1 font-weight-bold">
                {{ account.idTokenClaims.given_name | firstCharacter }}
              </span>
            </span>
          </div>
          <div class="d-flex flex-column">
            <a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
              {{ account.idTokenClaims.name }}
            </a>
            <!--<div class="text-muted mt-1">Application Developer</div>-->
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-icon mr-1">
                    <Mail :size="16" class="text-primary" />
                  </span>
                  <span class="navi-text text-muted text-hover-primary">
                    {{ account.email }}
                  </span>
                </span>
              </a>
            </div>
            <button class="btn btn-light-primary btn-bold" @click="onLogout">Abmelden</button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import { LOGOUT } from '@/core/user/stores/auth.module.js';
import KTLayoutQuickUser from '@/assets/js/layout/extended/quick-user.js';
import { mapState } from 'vuex';
import { Mail, X } from 'lucide-vue';

export default {
  name: 'KTQuickUser',
  components: { Mail, X },
  data() {
    return {};
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs['kt_quick_user']);
  },
  methods: {
    onLogout() {
      this.$store.dispatch(LOGOUT);
    },
  },
  filters: {
    firstCharacter(text) {
      return text.charAt(0);
    },
  },
  computed: {
    ...mapState({
      account: state => state.auth.account,
    }),
  },
};
</script>
